import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import router from './modules/router'
import echarts from './modules/echarts'
import getters from './getters'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    router,
    echarts
  },
  getters,
  plugins: [
    createPersistedState({ storage: window.sessionStorage, paths: ['app', 'router'] })
  ]
})

export default store
